export const ServicesNames = Object({
    "mifid": [
        ['Compliance Wks', '/Service'],
        ['dati storici', '/Service'],
        ['book consolidato', '/Service'],
        ['best execution engine', '/Service'],
        ['otc market place', '/Service'],
    ],
    "feed": [
        ['Ftp', '/Service'],
        ['Api', '/Service']
    ],
    "finsite": [
        ['Basic', '/Service'],
        ['Premium', '/Service'],
        ['Full', '/Service']
    ],
    "services": [
        // ['Marketconnect','/Service'],
        ['Market Connect Web', '/Service'],
        ['Market Connect Client', '/Service'],
        // ['mifid', '/ServiceServices'],
        ['Market Connect Feed', '/ServiceServices'],
        ['Finsite', '/ServiceServices'],
        ['Investor Relations', '/Service'],
        ['Web Services', '/Service']
    ]
})





